import { render, staticRenderFns } from "./ProvisionService.vue?vue&type=template&id=e2e6951a&scoped=true&"
import script from "./ProvisionService.vue?vue&type=script&lang=js&"
export * from "./ProvisionService.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionService.vue?vue&type=style&index=0&id=e2e6951a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e6951a",
  null
  
)

export default component.exports